<div class="row align-items-center">
  <div class="col-auto">
    @if (this.address) {
      <div>{{ this.address }}</div>
    }
    @if (this.address2) {
      <div>{{ this.address2 }}</div>
    }
    @if (this.zipCode || this.city) {
      <div>
        @if (this.zipCode) {
          <span>{{ this.zipCode }} </span>
        }
        @if (this.city) {
          <span>{{ this.city }}</span>
        }
      </div>
    }
    @if (this.country) {
      <div>{{ this.country }}</div>
    }
  </div>
  @if (
    this.country || this.city || this.zipCode || this.address2 || this.address
    ) {
    <a
      class="mdi mdi-map-marker-outline col-auto h5"
      href="https://www.google.com/maps/search/?api=1&query={{
        this.address
      }}+{{ this.city }}+{{ this.zipCode }}"
      target="_blank"
    ></a>
  }
</div>
